<header *ngIf="(authenticationService.organisation$ | async)">
  <img src="{{ (authenticationService.organisation$ | async)?.logo }}" alt="{{ (authenticationService.organisation$ | async)?.display_name }}">
</header>
<fury-page-layout>
  <fury-page-layout-content @fadeInUp>
    <fury-container>
      <form [formGroup]="webformService.normalForm">
        <div fxLayout="row" fxLayoutGap="36px">
          <div (sectionChange)="onSectionChange($event)" [spiedTags]="['H2']" furyScrollSpy fxFlex="100" fxFlex.gt-sm="80" fxLayout="column">
            <h1>Melding openbare ruimte</h1>
            <ng-container *ngIf="reportsMapUrl">
              <p>Voordat u een melding doet kunt u op de <a href="{{ reportsMapUrl }}" target="_blank">meldingenkaart</a> zien welke meldingen bekend zijn bij
                de gemeente.</p>
            </ng-container>
            <p>
              Geef aan wat er aan de hand is en waar u dit heeft gezien. Wij nemen uw melding zo snel mogelijk in behandeling.
              <br>
              <i>Vragen gemarkeerd met een <sup>*</sup> zijn verplicht om in te vullen.</i>
            </p>
            <h2 id="melding">Uw melding</h2>
            <div *ngIf="filters.headCategories.data.length || filters.headCategories.isLoading"
                 [class.has-error]="webformService.normalForm.controls.head_category_id.errors && (webformService.normalForm.controls.head_category_id.touched || controlForm)"
                 class="container">
              <mat-icon aria-hidden="true">warning</mat-icon>
              <mat-label>Was voor een soort melding wilt u maken? <sup>*</sup></mat-label>
              <select *ngIf="filters.headCategories.data" formControlName="head_category_id">
                <option [value]="null">Selecteer de soort melding</option>
                <option *ngFor="let data of filters.headCategories.data" [value]="data.id">{{ data.name }}</option>
              </select>
              <fury-loading-overlay [isLoading]="filters.headCategories.isLoading"></fury-loading-overlay>
              <mat-error>Soort overlast is niet gevuld.</mat-error>
            </div>
            <div *ngIf="selectedHeadCategoryNote" [innerHTML]="selectedHeadCategoryNote" class="note"></div>
            <ng-container *ngIf="!isHeadCategoryAnExternalLink()">
              <div *ngIf="filters.subCategories.data.length || filters.subCategories.isLoading"
                   [class.has-error]="webformService.normalForm.controls.sub_category_id.errors && (webformService.normalForm.controls.sub_category_id.touched || controlForm)"
                   class="container">
                <mat-icon aria-hidden="true">warning</mat-icon>
                <mat-label>Tot welke subcategorie behoort de melding? <sup>*</sup></mat-label>
                <select *ngIf="filters.subCategories.data" formControlName="sub_category_id">
                  <option [value]="null">Selecteer een subcategorie</option>
                  <option *ngFor="let data of filters.subCategories.data" [value]="data.id">{{ data.name }}</option>
                </select>
                <fury-loading-overlay [isLoading]="filters.subCategories.isLoading"></fury-loading-overlay>
                <mat-error>Specificeer het soort overlast is niet gevuld.</mat-error>
              </div>
              <div *ngIf="selectedSubCategoryNote" [innerHTML]="selectedSubCategoryNote" class="note"></div>
              <ng-container *ngIf="!isSubCategoryAnExternalLink()">
                <div
                  [class.has-error]="webformService.normalForm.controls.attachments.errors && (webformService.normalForm.controls.attachments.touched || controlForm)"
                  class="container">
                  <mat-icon aria-hidden="true">warning</mat-icon>
                  <mat-label>Fotos' van melding</mat-label>
                  <p>Toevoegen van een foto is niet verplicht maar kan handig zijn.</p>
                  <div (click)="uploadAttachments.open()" class="container-uploader">
                    Sleep uw bestanden hierheen of selecteer de bestanden (klik hier)
                    <ngx-mat-file-input #uploadAttachments (change)="detectUploadAttachments($event)" [multiple]="true"
                                        formControlName="attachmentsContainer"></ngx-mat-file-input>
                  </div>
                  <div #attachmentsPlaceholder></div>
                  <mat-hint class="mat-error" *ngIf="attachmentIgnored">
                    Eén van de door u aangeleverde bestanden wordt door ons niet geaccepteerd en zal niet worden verstuurd:
                    {{ attachmentIgnored }}
                  </mat-hint>
                  <mat-hint class="mat-error" *ngIf="attachmentCountExceeded">
                    Er kunnen maximaal {{ acceptedMaxAttachments }} bijlages worden toegevoegd.
                  </mat-hint>
                  <mat-hint class="mat-error" *ngIf="attachmentTotalSizeExceeded">
                    De maximale grootte voor bijlage(s) is {{ acceptedMaxSizeAttachments / 1024 / 1024 }}MB.
                  </mat-hint>
                  <mat-hint>
                    Maximaal {{ acceptedMaxAttachments }} bestanden toevoegen in bestandsformat .jpg, .png, .pdf, .mp4, .flv, .docx, en .xlsx niet groter
                    als {{ acceptedMaxSizeAttachments / 1024 / 1024 }}MB in
                    totaal.
                  </mat-hint>
                </div>


                <div
                  [class.has-error]="webformService.normalForm.controls.description.errors && (webformService.normalForm.controls.description.touched || controlForm)"
                  class="container">
                  <mat-icon aria-hidden="true">warning</mat-icon>
                  <mat-label>Toelichting van uw melding <sup>*</sup></mat-label>
                  <textarea formControlName="description" placeholder="Beschrijf zo duidelijk mogelijk wat er aan de hand is"
                            maxlength="5000" rows="4" class="sentry-mask"></textarea>
                  <mat-hint class="word-counter">{{ webformService.normalForm.controls.description.value.length }} / 5000</mat-hint>
                </div>


                <h2 id="melding-locatie">Locatie van uw melding <sup>*</sup></h2>
                <p>De locatie van de melding kan eenvoudig worden toegevoegd door op de gewenste plek op de kaart te klikken. Daarnaast is het mogelijk om het
                  adres handmatig in te voeren in het veld onder de kaart.</p>
                <div (leafletClick)="onMapClick($event)" (leafletMapReady)="leafletMapService.init($event)"
                     [leafletOptions]="leafletMapService.mapOptions"
                     class="map"
                     id="map"
                     leaflet></div>
                <leaflet-loading-control
                  [map]='leafletMapService.mapContainer'
                  [options]="leafletMapService.loadingOptions"
                ></leaflet-loading-control>
                <div
                  [class.has-error]="webformService.normalForm.controls.report_location.errors && (webformService.normalForm.controls.report_location.touched || controlForm)"
                  class="container">
                  <mat-icon aria-hidden="true">warning</mat-icon>
                  <mat-label>Locatie van melding <sup>*</sup></mat-label>
                  <div fxLayout="column" fxLayout.gt-md="row" fxLayoutGap="16px">
                    <input [matAutocomplete]="suggestReportLocation" formControlName="report_location" (blur)="validateReportLocation()"
                           placeholder="Typ en selecteer de straatnaam, of klik op de kaart.">
                    <fury-loading-overlay [isLoading]="isLoadingReportLocations"></fury-loading-overlay>
                    <mat-autocomplete #suggestReportLocation="matAutocomplete" [displayWith]="formatLocationDropdown">
                      <mat-option *ngFor="let option of suggestReportLocations" [value]="option">
                        {{ option.weergavenaam }}
                      </mat-option>
                    </mat-autocomplete>
                    <div>
                      <button color="secondary" mat-button type="button" (click)="getUserLocation()">
                        <mat-icon>gps_fixed</mat-icon>
                        Gebruik mijn huidige locatie
                      </button>
                    </div>
                  </div>
                  <mat-error *ngIf="!webformService.normalForm.controls.report_location.errors?.invalid">
                    Start met het typen van de straatnaam en het huisnummer, kies daarna de juiste plaats is niet gevuld.
                  </mat-error>
                  <mat-error *ngIf="webformService.normalForm.controls.report_location.errors?.invalid">
                    Selecteer het adres in de locatie suggestie voordat u verder gaat.
                  </mat-error>
                  <mat-error *ngIf="userLocationError">
                    Uw locatie is niet beschikbaar.
                  </mat-error>
                </div>
                <div
                  [class.has-error]="webformService.normalForm.controls.report_location_description.errors && (webformService.normalForm.controls.report_location_description.touched || controlForm)"
                  class="container">
                  <mat-icon aria-hidden="true">warning</mat-icon>
                  <mat-label>Toelichting locatie overlast</mat-label>
                  <textarea matInput formControlName="report_location_description"
                            placeholder="Welke informatie is relevant voor de locatie overlast?"></textarea>
                  <mat-hint class="word-counter">{{ webformService.normalForm.controls.report_location_description.value.length }} / 500</mat-hint>
                </div>


                <h2 id="melder">Uw contact gegevens</h2>
                <p>U kunt hieronder uw persoonlijke gegevens invullen. Deze gegevens zullen uitsluitend worden gebruikt om u op de hoogte te houden. U bent niet
                  verplicht om deze gegevens in te vullen</p>
                <div class="container">
                  <div class="checkbox grey">
                    <input [value]="true" formControlName="reporter_anonymous" id="reporter_anonymous" type="checkbox">
                    <label for="reporter_anonymous">
                      <span></span>
                      Dit formulier anoniem indienen
                    </label>
                  </div>
                </div>
                <div *ngIf="webformService.normalForm.controls.reporter_anonymous.value" class="note">
                  Als u een melding anoniem indient, kan het zijn dat wij onvoldoende informatie hebben om een onderzoek op te starten. We kunnen
                  u niet bellen of mailen voor meer informatie. We kunnen ook niet achterhalen of de overlast op dit moment nog speelt. We vragen
                  u daarom om uw contactgegevens aan ons door te geven. Wij delen uw contactgegevens niet met de (vermoedelijke) veroorzaker.
                </div>
                <ng-container *ngIf="!webformService.normalForm.controls.reporter_anonymous.value">
                  <div class="container" fxLayout="column" fxLayout.gt-xs="row" fxLayoutGap="0" fxLayoutGap.gt-xs="16px">
                    <div fxFlex.gt-xs="20">
                      <mat-label>Aanhef</mat-label>
                      <select formControlName="reporter_prefix" class="sentry-mask">
                        <option *ngFor="let data of filters.personPrefix.data" [value]="data.id">{{ data.name }}</option>
                      </select>
                    </div>
                    <div fxFlex.gt-xs="20">
                      <mat-label>Voorletters</mat-label>
                      <input formControlName="reporter_initials" type="text" class="sentry-mask">
                    </div>
                    <div fxFlex.gt-xs="60">
                      <mat-label>Achternaam</mat-label>
                      <input formControlName="reporter_lastname" type="text" class="sentry-mask">
                    </div>
                  </div>
                  <div
                    [class.has-error]="webformService.normalForm.controls.reporter_location.errors"
                    class="container" fxLayout="column">
                    <mat-icon aria-hidden="true">warning</mat-icon>
                    <div fxLayout="column" fxLayout.gt-xs="row" fxLayoutGap="0" fxLayoutGap.gt-xs="16px">
                      <div fxFlex.gt-xs="20">
                        <mat-label>Postcode</mat-label>
                        <input formControlName="reporter_postalcode" type="text" class="sentry-mask" (keyup)="updateReporterAddress()">
                      </div>
                      <div fxFlex.gt-xs="20">
                        <mat-label>Huisnummer</mat-label>
                        <input formControlName="reporter_house_number_with_addition" type="text" class="sentry-mask" (keyup)="updateReporterAddress()">
                      </div>
                      <div fxFlex.gt-xs="30">
                        <mat-label>Straatnaam</mat-label>
                        <input formControlName="reporter_streetname" type="text" class="sentry-mask">
                      </div>
                      <div fxFlex.gt-xs="30">
                        <mat-label>Plaats</mat-label>
                        <input formControlName="reporter_city" type="text" class="sentry-mask">
                      </div>
                    </div>
                    <mat-error>
                      U hebt een ongeldige locatie ingevoerd, probeer het alstublieft opnieuw.
                    </mat-error>
                  </div>
                  <div fxLayout="column" fxLayout.gt-xs="row" fxLayoutGap="0" fxLayoutGap.gt-xs="16px">
                    <div fxFlex.gt-xs="50">
                      <div
                        [class.has-error]="webformService.normalForm.controls.reporter_email.errors && (webformService.normalForm.controls.reporter_email.touched || controlForm)"
                        class="container">
                        <mat-icon aria-hidden="true">warning</mat-icon>
                        <mat-label>E-mail <sup
                          *ngIf="webformService.normalForm.controls.reporter_email.hasValidator(Validators.required)">*</sup>
                        </mat-label>
                        <input formControlName="reporter_email" type="email" class="sentry-mask">
                        <mat-error>E-mail is niet gevuld.</mat-error>
                      </div>
                    </div>
                    <div fxFlex.gt-xs="50">
                      <div
                        [class.has-error]="webformService.normalForm.controls.reporter_phone.errors && (webformService.normalForm.controls.reporter_phone.touched || controlForm)"
                        class="container">
                        <mat-label>Telefoonnummer</mat-label>
                        <input formControlName="reporter_phone" type="tel" class="sentry-mask">
                        <mat-error>Voer het telefoonnummer in zonder spaties of streepjes.</mat-error>
                      </div>
                    </div>
                  </div>
                  <div class="container">
                    <div class="checkbox">
                      <input [value]="true" checked="checked" formControlName="reporter_notify" id="reporter_notify" type="checkbox">
                      <label for="reporter_notify">
                        <span></span>
                        Ja, ik wil op de hoogte worden gehouden van mijn melding. Een e-mailadres is verplicht.
                      </label>
                    </div>
                  </div>
                </ng-container>
                <div *ngIf="controlForm && webformService.normalForm.invalid" class="note warning">
                  Let op: Niet alle (verplichte) velden zijn op de correcte wijze ingevuld.
                </div>
                <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap="16px" fxLayoutGap.gt-sm="32px">
                  <button color="secondary" fxFlex="100" fxFlex.gt-sm="50" mat-button routerLink="/" type="button">
                    Annuleer melding
                    <mat-icon>cancel</mat-icon>
                  </button>
                  <button (click)="checkForm()" color="primary" fxFlex="100" fxFlex.gt-sm="50" mat-button type="button">
                    Controle melding
                    <mat-icon>play_circle_outline</mat-icon>
                  </button>
                </div>
              </ng-container>
            </ng-container>
          </div>
          <div class="steps-container" fxFlex.gt-sm="212px" fxHide fxLayout="row" fxLayoutAlign="flex-end" fxShow.gt-sm>
            <ul class="steps">
              <li [class.active]="currentSection === 'melding'" class="step">Uw melding</li>
              <li [class.active]="currentSection === 'melding-locatie'" class="step">Locatie van uw melding</li>
              <li [class.active]="currentSection === 'melder'" class="step">Uw contact gegevens</li>
              <li [class.active]="currentSection === 'controle'" class="step">Controle melding</li>
              <li *ngIf="isLocal" (click)="log()">log</li>
            </ul>
          </div>
        </div>
      </form>
    </fury-container>
  </fury-page-layout-content>
</fury-page-layout>
